window.videos = () => {
    return {
        currentFilters: [],
        visibleClasses: 'show-all-videos',
        toggle(tag) {
            if (this.currentFilters.includes(tag)) {
                this.currentFilters = this.currentFilters.filter(
                    (t) => t !== tag,
                );
            } else {
                this.currentFilters.push(tag);
            }

            this.visibleClasses = this.currentFilters
                .map((tag) => `showing-video-tag-${tag}`)
                .join(' ');
        },
    };
};
